import { MenuItem } from 'primeng/api';
import { Estado, EstadoForm } from '@models/.';

export function transformStateData(state: Estado | null): Estado | null {
  if (!state) return null;
  
  return {
    ...state,
  };
}

export function transformStateForm(state: Estado): EstadoForm {
  return {
    ...state,
  };
}

export function transformStateDropdown(categories: Estado[]): MenuItem[] {
  if (categories.length === 0) return [];
  
  return  categories.map((state) => {
    const { descripcion, idEstado } = state;
    
    return {
      label: descripcion,
      value: { idEstado, descripcion },
    };
  })
}